import React, { useState, useEffect, useRef } from 'react';
import { 
  Home, 
  DollarSign, 
  MessageCircle, 
  Settings, 
  User,
  Bell, Filter ,
  LogOut,
  ChevronUp,
  ChevronDown,
  TrendingUp,
  Calendar,
  CreditCard,
  PieChart,
  BarChart3,
  Clock,
  Target,
  Zap,
  Shield,
  Plus,
  ArrowUpRight,
  ArrowDownLeft,
  Sun,
  Moon,
  CheckCircle2,
  AlertCircle,
  Info,
  Wallet,
  Receipt,
  TrendingDown,
  Eye,
  EyeOff,
  ChevronRight,
  ChevronLeft,
  Smartphone,
  Activity, HelpCircle,
  Send, Globe, Twitter, Github, Linkedin,
  Download,
  FileText,
  Settings2Icon,
  PlusCircle,
  Calculator
} from 'lucide-react';
import { LineChart, Pie, Line, AreaChart, Area, XAxis, YAxis, ResponsiveContainer, PieChart as RechartsPieChart, Cell } from 'recharts';
import LoanApplication from './applyloan';
import PayLoan from './payloan';
import UserSettings from './settings';
import UserProfile from './profile';
import LoanCalculator from './calculator';
import logo from "../../assets/logo.png";

const BorrowersHome = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isBalanceVisible, setIsBalanceVisible] = useState(true);
  const [currentView, setCurrentView] = useState('dashboard');
  const [currentCard, setCurrentCard] = useState(0);
  const [adCarousel, setAdCarousel] = useState(0);

    const [lastScrollY, setLastScrollY] = useState(0);
  const [visible, setVisible] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const headerRef = useRef(null);
 

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const headerHeight = headerRef.current?.offsetHeight || 0;
      
      // Add background when scrolled past header
      setScrolled(currentScrollY > headerHeight);
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px - hide header
        setVisible(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 100) {
        // Scrolling up or near top - show header
        setVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);


  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  

  const theme = {
    bg: isDarkMode ? 'from-gray-950 via-slate-900 to-gray-900' : 'from-gray-50 via-blue-50 to-indigo-50',
    cardBg: isDarkMode ? 'bg-gray-900/40 border-gray-800/30' : 'bg-white/60 border-gray-200/40',
    navBg: isDarkMode ? 'bg-gray-900/20' : 'bg-white/20',
    text: isDarkMode ? 'text-white' : 'text-gray-900',
    textSecondary: isDarkMode ? 'text-gray-300' : 'text-gray-600',
    textMuted: isDarkMode ? 'text-gray-400' : 'text-gray-500',
    accent: 'text-blue-500',
    success: 'text-emerald-500',
    warning: 'text-amber-500',
    error: 'text-red-500'
  };

  const loanSummary = {
    totalBalance: 185900,
    totalPaid: 65600,
    monthlyPayment: 2345,
    nextDueDate: 'Dec 15',
    creditScore: 745,
    activeLoans: 3,
    totalOriginal: 251500
  };

  const balanceCards = [
    {
      title: 'Total Outstanding',
      value: loanSummary.totalBalance,
      change: -12500,
      changePercent: -6.3,
      icon: Wallet,
      color: 'from-blue-500 to-cyan-400'
    },
    {
      title: 'Monthly Payment',
      value: loanSummary.monthlyPayment,
      change: +150,
      changePercent: +6.8,
      icon: Calendar,
      color: 'from-purple-500 to-pink-400'
    },
    {
      title: 'Credit Score',
      value: loanSummary.creditScore,
      change: +12,
      changePercent: +1.6,
      icon: TrendingUp,
      color: 'from-emerald-500 to-teal-400'
    }
  ];

  const loanData = [
    {
      id: 1,
      title: 'Personal Loan',
      bank: 'Chase',
      amount: 24500,
      remaining: 15200,
      nextPayment: 485,
      dueDate: 'Dec 15',
      progress: 38,
      rate: 6.5,
      status: 'current'
    },
    {
      id: 2,
      title: 'Auto Loan',
      bank: 'Wells Fargo',
      amount: 42000,
      remaining: 28400,
      nextPayment: 620,
      dueDate: 'Dec 18',
      progress: 32,
      rate: 4.2,
      status: 'current'
    },
    {
      id: 3,
      title: 'Home Loan',
      bank: 'Bank of America',
      amount: 185000,
      remaining: 142300,
      nextPayment: 1240,
      dueDate: 'Dec 20',
      progress: 23,
      rate: 3.8,
      status: 'current'
    }
  ];

  const quickActions = [
    { id: 1, icon: Send, label: 'Pay', color: 'bg-blue-500' },       // Default active
    { id: 2, icon: Plus, label: 'Apply', color: 'bg-gray-600' },
    { id: 3, icon: Calculator, label: 'Calculator', color: 'bg-gray-600' },
    { id: 4, icon: FileText, label: 'Reports', color: 'bg-gray-600' }
    ];

   const [activeAction, setActiveAction] = useState(quickActions[0].id);

  const recentActivity = [
    { type: 'payment', amount: 485, date: 'Today', status: 'completed', loan: 'Personal Loan', color: 'bg-emerald-500' },
    { type: 'payment', amount: 620, date: 'Yesterday', status: 'completed', loan: 'Auto Loan', color: 'bg-blue-500' },
    { type: 'application', amount: 15000, date: '2 days ago', status: 'approved', loan: 'Personal Loan', color: 'bg-purple-500' },
    { type: 'payment', amount: 1240, date: '3 days ago', status: 'completed', loan: 'Home Loan', color: 'bg-orange-500' }
  ];

  const marketData = [
    { name: 'Jan', value: 2400 },
    { name: 'Feb', value: 2100 },
    { name: 'Mar', value: 2800 },
    { name: 'Apr', value: 2600 },
    { name: 'May', value: 2900 },
    { name: 'Jun', value: 2345 }
  ];

  const pieData = [
    { name: 'Paid', value: loanSummary.totalPaid, fill: '#10B981' },
    { name: 'Outstanding', value: loanSummary.totalBalance, fill: '#3B82F6' }
  ];

  const adBanners = [
    {
      title: 'Low Rate Offer',
      subtitle: '2.9% APR Personal Loans',
      cta: 'Apply Now',
      color: 'from-blue-600 to-purple-600'
    },
    {
      title: 'Refinance Special',
      subtitle: 'Save up to $200/month',
      cta: 'Calculate',
      color: 'from-emerald-600 to-teal-600'
    },
    {
      title: 'Credit Boost',
      subtitle: 'Improve your score',
      cta: 'Learn More',
      color: 'from-orange-600 to-red-600'
    }
  ];

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatNumber = (num) => {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'k';
    }
    return num.toString();
  };

 

  // Helper function to calculate days until due date
  const calculateDaysUntilDue = (dueDate) => {
    // Simple implementation - in real app, parse the date properly
    const daysMap = {
      'Dec 15': 5,
      'Dec 18': 8,
      'Dec 20': 10
    };
    return daysMap[dueDate] || 15;
  };

  // Helper function to calculate average interest rate
  const calculateAverageInterest = (loans) => {
    const total = loans.reduce((sum, loan) => sum + loan.rate, 0);
    return (total / loans.length).toFixed(1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCard((prev) => (prev + 1) % balanceCards.length);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setAdCarousel((prev) => (prev + 1) % adBanners.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const renderMainContent = () => {
   
    switch (currentView) { 
        case 'applyloan':
            return <LoanApplication theme={theme} isDarkMode={isDarkMode} />;
        case 'payloan':
            return <PayLoan theme={theme} isDarkMode={isDarkMode}/>; 
        case 'calculator':
            return <LoanCalculator theme={theme} isDarkMode={isDarkMode}/>; 
        case 'profile': 
            return <UserProfile theme={theme} isDarkMode={isDarkMode}/>;
        case 'settings': 
            return <UserSettings theme={theme} isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
        case 'dashboard':
            return (
                <div className="max-w-7xl mx-auto">
            {/*  Circular Balance Carousel */}
                <div className="mb-8">
                     <div className="relative">
                       <div className="overflow-hidden">
                         <div
                           className="flex transition-transform duration-1000 ease-out"
                           style={{ transform: `translateX(-${currentCard * 100}%)` }}
                         >
                           {balanceCards.map((card, index) => {
                             // Calculate progress
                             const progressPercentage =
                               card.title === "Total Outstanding"
                                 ? Math.round(
                                     (loanSummary.totalPaid /
                                       (loanSummary.totalBalance + loanSummary.totalPaid)) *
                                       100
                                   )
                                 : card.title === "Credit Score"
                                 ? Math.round((card.value / 850) * 100)
                                 : 50;
               
                             return (
                               <div key={index} className="w-full flex-shrink-0 px-4">
                                 <div
                                   className={`${theme.cardBg} backdrop-blur-xl rounded-3xl p-6 border mx-1`}
                                 >
                                   {/* Card Header */}
                                   <div className="flex items-center space-x-3 mb-4">
                                     <div
                                       className={`w-12 h-12 bg-gradient-to-r ${card.color} rounded-2xl flex items-center justify-center`}
                                     >
                                       <card.icon className="w-6 h-6 text-white" />
                                     </div>
                                     <div>
                                       <p className={`text-sm ${theme.textMuted}`}>
                                         {card.title}
                                       </p>
                                       <div className="flex items-center space-x-2">
                                         <h2
                                           className={`text-2xl sm:text-3xl font-bold ${theme.text}`}
                                         >
                                           {card.title === "Credit Score"
                                             ? card.value
                                             : formatCurrency(card.value)}
                                         </h2>
                                         {card.title === "Total Outstanding" && (
                                           <button
                                             onClick={() =>
                                               setIsBalanceVisible(!isBalanceVisible)
                                             }
                                             className={`p-1 ${theme.cardBg} rounded-lg border`}
                                           >
                                             {isBalanceVisible ? (
                                               <EyeOff
                                                 className={`w-4 h-4 ${theme.textMuted}`}
                                               />
                                             ) : (
                                               <Eye
                                                 className={`w-4 h-4 ${theme.textMuted}`}
                                               />
                                             )}
                                           </button>
                                         )}
                                       </div>
                                     </div>
                                   </div>
               
                                   {/* Progress Section */}
                                   <div className="flex items-center justify-between mb-4">
                                     <div className="flex items-center space-x-2">
                                       {card.change > 0 ? (
                                         <TrendingUp className="w-4 h-4 text-emerald-500" />
                                       ) : (
                                         <TrendingDown className="w-4 h-4 text-red-500" />
                                       )}
                                       <span
                                         className={`text-sm font-medium ${
                                           card.change > 0 ? "text-emerald-500" : "text-red-500"
                                         }`}
                                       >
                                         {card.change > 0 ? "+" : ""}
                                         {formatNumber(Math.abs(card.change))}
                                       </span>
                                       <span className={`text-xs ${theme.textMuted}`}>
                                         this month
                                       </span>
                                     </div>
               
                                     
                                   </div>
               
                                   
                                 </div>
                               </div>
                             );
                           })}
                         </div>
                       </div>
               
                       {/* Carousel Indicators */}
                       <div className="flex justify-center space-x-2 mt-4">
                         {balanceCards.map((_, index) => (
                           <button
                             key={index}
                             onClick={() => setCurrentCard(index)}
                             className={`w-2 h-2 rounded-full transition-all ${
                               index === currentCard ? "bg-blue-500 w-6" : "bg-gray-300"
                             }`}
                           />
                         ))}
                       </div>
                     </div>
                   </div>


                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Left Column - Mobile: Full Width, Desktop: 2 columns */}
                    <div className="lg:col-span-2 space-y-6">
                        
                        {/* Quick Actions */}
                        <div>
                            <div className="flex justify-center">
                                <div className="flex items-center space-x-6">
                                    {quickActions.map((action) => (
                                    <div key={action.id} className="flex flex-col items-center">
                                        <button
                                        onClick={() => {
                                            setActiveAction(action.id);
                                            switch(action.label) {
                                            case 'Pay':
                                                setCurrentView('payloan');
                                                break;
                                            case 'Apply':
                                                setCurrentView('applyloan');
                                                break;
                                            case 'Calculator':
                                                setCurrentView('calculator');
                                                break;
                                            case 'Reports':
                                                // Add reports functionality here if needed
                                                break;
                                            default:
                                                setCurrentView('dashboard');
                                            }
                                        }}
                                        className={`
                                            ${action.color} rounded-full flex items-center justify-center
                                            transition-all shadow-md hover:scale-105
                                            ${activeAction === action.id ? 'ring-2 ring-blue-500 scale-110' : 'w-12 h-12'}
                                        `}
                                        >
                                        <action.icon
                                            className={`text-white ${activeAction === action.id ? 'w-7 h-7' : 'w-5 h-5'}`}
                                        />
                                        </button>
                                        <span className={`mt-2 text-xs font-medium ${theme.textMuted}`}>
                                        {action.label}
                                        </span>
                                    </div>
                                    ))}
                                </div>
                                </div>
                        
                        </div>

                        {/* Balanced Active Loans Section */}
                     
                        <div className="mb-8">
                        {/* Enhanced Header with Interactive Controls */}
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center">
                            <div className="relative mr-3">
                                <div className="w-2 h-6 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
                                <div className="absolute inset-0 bg-blue-400 rounded-full opacity-50 animate-pulse"></div>
                            </div>
                            <h3 className={`text-lg font-semibold ${theme.text}`}>Active Loans</h3>
                            <div className="ml-2 w-5 h-5 flex items-center justify-center bg-blue-500/10 rounded-full">
                                <span className="text-xs font-medium text-blue-500">{loanData.length}</span>
                            </div>
                            </div>
                            
                            <div className="flex items-center space-x-2">
                            <button className={`flex items-center text-sm ${theme.textMuted} hover:${theme.text} transition-colors`}>
                                <Filter className="w-3 h-3 mr-1" />
                                Filter
                            </button>
                            <div className="w-px h-4 bg-gray-500/30"></div>
                            <button className={`flex items-center text-sm ${theme.textMuted} hover:${theme.text} transition-colors`}>
                                <BarChart3 className="w-3 h-3 mr-1" />
                                Compare
                            </button>
                            </div>
                        </div>
                        
                        {/* Loans Grid with Advanced Visualization */}
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                            {loanData.map((loan) => {
                            const progressPercentage = 100 - Math.round((loan.remaining / loan.amount) * 100);
                            const daysUntilDue = calculateDaysUntilDue(loan.dueDate);
                            
                            return (
                                <div key={loan.id} className={`${theme.cardBg} backdrop-blur-xl rounded-2xl p-5 border ${theme.border} transition-all duration-300 hover:shadow-lg group`}>
                                {/* Loan Header with Status */}
                                <div className="flex items-start justify-between mb-5">
                                    <div className="flex-1">
                                    <div className="flex items-center mb-2">
                                        <div className={`w-3 h-3 rounded-full mr-2 ${
                                        daysUntilDue <= 3 ? 'bg-amber-500 animate-pulse' : 
                                        daysUntilDue <= 7 ? 'bg-blue-500' : 'bg-emerald-500'
                                        }`}></div>
                                        <h4 className={`font-semibold ${theme.text} text-base`}>{loan.title}</h4>
                                    </div>
                                    <p className={`text-sm ${theme.textMuted} mb-3`}>{loan.bank}</p>
                                    
                                    {/* Progress Bar with Percentage */}
                                    <div className="mb-4">
                                        <div className="flex justify-between text-xs mb-2">
                                        <span className={theme.textMuted}>Paid: {progressPercentage}%</span>
                                        <span className={theme.textMuted}>Remaining: {formatCurrency(loan.remaining)}</span>
                                        </div>
                                        <div className="w-full bg-gray-700/30 rounded-full h-2">
                                        <div 
                                            className="bg-gradient-to-r from-blue-500 to-emerald-500 h-2 rounded-full transition-all duration-1000"
                                            style={{ width: `${progressPercentage}%` }}
                                        ></div>
                                        </div>
                                    </div>
                                    </div>
                                    
                                    {/* Interest Rate Badge */}
                                    <div className={`ml-3 px-2 py-1 rounded-lg text-xs font-medium ${
                                    loan.rate <= 4 ? 'bg-emerald-500/10 text-emerald-500' :
                                    loan.rate <= 7 ? 'bg-amber-500/10 text-amber-500' :
                                    'bg-red-500/10 text-red-500'
                                    }`}>
                                    {loan.rate}%
                                    </div>
                                </div>
                                
                                {/* Loan Details Grid */}
                                <div className="grid grid-cols-2 gap-4 mb-5">
                                    <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-gray-800/50' : 'bg-gray-100/50'}`}>
                                    <div className={`text-xs ${theme.textMuted} mb-1`}>Next Payment</div>
                                    <div className={`text-sm font-bold ${theme.text}`}>{formatCurrency(loan.nextPayment)}</div>
                                    </div>
                                    
                                    <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-gray-800/50' : 'bg-gray-100/50'}`}>
                                    <div className={`text-xs ${theme.textMuted} mb-1`}>Due Date</div>
                                    <div className={`text-sm font-bold ${
                                        daysUntilDue <= 3 ? theme.warning : theme.text
                                    }`}>
                                        {loan.dueDate}
                                        {daysUntilDue <= 7 && (
                                        <span className="text-xs ml-1">({daysUntilDue}d)</span>
                                        )}
                                    </div>
                                    </div>
                                </div>
                                
                                {/* Action Buttons */}
                                <div className="flex space-x-2">
                                    <button className={`flex-1 py-2 px-3 rounded-lg text-xs font-medium transition-colors ${
                                    isDarkMode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'
                                    } text-white`}>
                                    Make Payment
                                    </button>
                                    <button className={`p-2 rounded-lg ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'} transition-colors`}>
                                    <ChevronRight className="w-4 h-4 text-gray-500" />
                                    </button>
                                </div>
                                </div>
                            );
                            })}
                        </div>
                        
                        {/* Quick Stats Summary */}
                        <div className={`mt-6 ${theme.cardBg} backdrop-blur-xl rounded-2xl p-4 border ${theme.border}`}>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="text-center">
                                <div className={`text-xs ${theme.textMuted} mb-1`}>Total Balance</div>
                                <div className={`text-sm font-bold ${theme.text}`}>{formatCurrency(loanSummary.totalBalance)}</div>
                            </div>
                            <div className="text-center">
                                <div className={`text-xs ${theme.textMuted} mb-1`}>Monthly Payment</div>
                                <div className={`text-sm font-bold ${theme.text}`}>{formatCurrency(loanSummary.monthlyPayment)}</div>
                            </div>
                            <div className="text-center">
                                <div className={`text-xs ${theme.textMuted} mb-1`}>Avg. Interest</div>
                                <div className={`text-sm font-bold ${theme.text}`}>
                                {calculateAverageInterest(loanData)}%
                                </div>
                            </div>
                            <div className="text-center">
                                <div className={`text-xs ${theme.textMuted} mb-1`}>Next Due</div>
                                <div className={`text-sm font-bold ${theme.warning}`}>{loanSummary.nextDueDate}</div>
                            </div>
                            </div>
                        </div>
                        </div>
                        
                        {/* Payment History Chart */}
                        <div className={`${theme.cardBg} backdrop-blur-xl rounded-2xl p-6 border`}>
                        <h3 className={`text-lg font-semibold ${theme.text} mb-4 flex items-center`}>
                            <Activity className="w-5 h-5 mr-2 text-blue-500" />
                            Payment Trend
                        </h3>
                        <div className="h-48">
                            <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={marketData}>
                                <defs>
                                <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.3}/>
                                    <stop offset="95%" stopColor="#3B82F6" stopOpacity={0}/>
                                </linearGradient>
                                </defs>
                                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: theme.textMuted }} />
                                <YAxis hide />
                                <Area 
                                type="monotone" 
                                dataKey="value" 
                                stroke="#3B82F6" 
                                strokeWidth={2}
                                fill="url(#areaGradient)" 
                                />
                            </AreaChart>
                            </ResponsiveContainer>
                        </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-6">
                        
                        {/* Recent Activity Section */}
                        <div className="mb-8">
                        {/* Enhanced Header with Interactive Controls */}
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center">
                            <div className="relative">
                                <div className="w-2 h-6 bg-gradient-to-b from-emerald-500 to-emerald-600 rounded-full mr-3"></div>
                                <div className="absolute inset-0 bg-emerald-400 rounded-full opacity-50 animate-pulse"></div>
                            </div>
                            <h3 className={`text-lg font-semibold ${theme.text}`}>Recent Activity</h3>
                            <div className="ml-2 w-5 h-5 flex items-center justify-center bg-emerald-500/10 rounded-full">
                                <span className="text-xs font-medium text-emerald-500">{recentActivity.length}</span>
                            </div>
                            </div>
                            
                            <div className="flex items-center space-x-2">
                            <button className={`p-1.5 rounded-lg ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} transition-colors`}>
                                <Filter className="w-4 h-4 text-gray-500" />
                            </button>
                            <button className={`p-1.5 rounded-lg ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} transition-colors`}>
                                <Calendar className="w-4 h-4 text-gray-500" />
                            </button>
                            </div>
                        </div>
                        
                        {/* Activity Timeline with Visual Enhancements */}
                        <div className="relative">
                            {/* Timeline connector line */}
                            <div className="absolute left-4 top-3 bottom-3 w-0.5 bg-gradient-to-b from-blue-500/20 to-emerald-500/20 z-0"></div>
                            
                            <div className="space-y-4 relative z-10">
                            {recentActivity.map((activity, index) => (
                                <div key={index} className={`${theme.cardBg} backdrop-blur-xl rounded-xl p-4 border ${theme.border} flex items-center justify-between transition-all duration-300 hover:shadow-lg`}>
                                <div className="flex items-center space-x-4 flex-1">
                                    {/* Status indicator with icon */}
                                    <div className="relative">
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                                        activity.type === 'payment' 
                                        ? 'bg-emerald-500/10' 
                                        : 'bg-blue-500/10'
                                    }`}>
                                        {activity.type === 'payment' ? (
                                        <ArrowUpRight className={`w-4 h-4 ${theme.success}`} />
                                        ) : (
                                        <Plus className={`w-4 h-4 ${theme.accent}`} />
                                        )}
                                    </div>
                                    {/* Pulse animation for very recent activities */}
                                    {activity.date === 'Today' && (
                                        <div className="absolute -inset-1 bg-emerald-500/20 rounded-full animate-ping"></div>
                                    )}
                                    </div>
                                    
                                    {/* Content with better information hierarchy */}
                                    <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between mb-1">
                                        <span className={`text-sm font-medium ${theme.text} truncate`}>
                                        {activity.type === 'payment' ? 'Payment Processed' : 'Loan Application'}
                                        </span>
                                        <span className={`text-xs font-medium ${
                                        activity.type === 'payment' ? theme.success : theme.accent
                                        }`}>
                                        {formatCurrency(activity.amount)}
                                        </span>
                                    </div>
                                    
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center space-x-2">
                                        <span className={`text-xs ${theme.textMuted}`}>{activity.loan}</span>
                                        <span className="w-1 h-1 rounded-full bg-gray-500/50"></span>
                                        <span className={`text-xs ${theme.textMuted}`}>{activity.date}</span>
                                        </div>
                                        
                                        {/* Status badge */}
                                        <div className={`px-2 py-0.5 rounded-full text-xs ${
                                        activity.status === 'completed' 
                                            ? 'bg-emerald-500/10 text-emerald-500' 
                                            : 'bg-blue-500/10 text-blue-500'
                                        }`}>
                                        {activity.status}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                
                                {/* Quick action button */}
                                <button className={`ml-3 p-1.5 rounded-lg ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'} transition-colors`}>
                                    <ChevronRight className="w-4 h-4 text-gray-500" />
                                </button>
                                </div>
                            ))}
                            </div>
                        </div>
                        
                        {/* View All Footer */}
                        <div className="mt-4 flex justify-center">
                            <button className={`flex items-center text-sm ${theme.accent} font-medium py-2 px-4 rounded-lg ${isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'} transition-colors`}>
                            <span>View All Activity</span>
                            <ChevronRight className="w-4 h-4 ml-1" />
                            </button>
                        </div>
                        </div>

                        {/* Promotional Carousel */}
                        <div className="relative overflow-hidden rounded-2xl">
                        <div 
                            className="flex transition-transform duration-500 ease-out"
                            style={{ transform: `translateX(-${adCarousel * 100}%)` }}
                        >
                            {adBanners.map((banner, index) => (
                            <div key={index} className="w-full flex-shrink-0">
                                <div className={`bg-gradient-to-r ${banner.color} rounded-2xl p-6 text-white`}>
                                <h3 className="font-bold text-lg mb-2">{banner.title}</h3>
                                <p className="text-sm opacity-90 mb-4">{banner.subtitle}</p>
                                <button className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-white/30 transition-colors">
                                    {banner.cta}
                                </button>
                                </div>
                            </div>
                            ))}
                        </div>
                        
                        <div className="flex justify-center space-x-1 mt-3">
                            {adBanners.map((_, index) => (
                            <div
                                key={index}
                                className={`w-1.5 h-1.5 rounded-full transition-all ${
                                index === adCarousel ? 'bg-white w-4' : 'bg-white/50'
                                }`}
                            />
                            ))}
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Footer */}
                        {/* Enhanced Premium Footer */}
                    <div className={`${theme.cardBg} backdrop-blur-xl rounded-2xl p-8 mt-24 border ${theme.border}`}>
                        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
                        {/* Left: Security & Certifications */}
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center space-x-2 group relative">
                            <div className={`p-1.5 rounded-lg ${isDarkMode ? 'bg-green-900/20' : 'bg-green-100'}`}>
                                <Shield className={`w-4 h-4 ${theme.success}`} />
                            </div>
                            <span className={`text-xs ${theme.text}`}>SSL Secured</span>
                            
                            {/* Security Tooltip */}
                            <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block w-40">
                                <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-gray-900'} text-white text-xs py-2 px-3 rounded-md shadow-lg`}>
                                <div className="font-medium mb-1">Bank-Level Security</div>
                                <div>256-bit encryption protecting your data</div>
                                </div>
                            </div>
                            </div>
                            
                            <div className="h-4 w-px bg-gray-500/30"></div>
                            
                            <div className="flex items-center space-x-2 group relative">
                            <div className={`p-1.5 rounded-lg ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-100'}`}>
                                <CheckCircle2 className={`w-4 h-4 ${theme.accent}`} />
                            </div>
                            <span className={`text-xs ${theme.text}`}>GDPR Compliant</span>
                            
                            {/* Compliance Tooltip */}
                            <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block w-48">
                                <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-gray-900'} text-white text-xs py-2 px-3 rounded-md shadow-lg`}>
                                <div className="font-medium mb-1">Data Protection</div>
                                <div>Your privacy is protected under GDPR regulations</div>
                                </div>
                            </div>
                            </div>

                            {/* System Status Indicator */}
                            <div className="h-4 w-px bg-gray-500/30"></div>
                            
                            <div className="flex items-center space-x-2">
                            <div className="relative">
                                <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                                <div className="absolute inset-0 bg-emerald-500 rounded-full animate-ping"></div>
                            </div>
                            <span className={`text-xs ${theme.text}`}>System Online</span>
                            </div>
                        </div>

                        {/* Center: Quick Links with Icons */}
                        <div className="flex items-center space-x-5">
                            <button className={`text-xs ${theme.textMuted} hover:${theme.accent} transition-colors flex items-center group`}>
                            <FileText className="w-3 h-3 mr-1" />
                            Privacy
                            <div className="absolute -top-6 hidden group-hover:block bg-black/80 text-white text-xs py-1 px-2 rounded">
                                Privacy Policy
                            </div>
                            </button>
                            
                            <div className="w-1 h-1 rounded-full bg-gray-500/30"></div>
                            
                            <button className={`text-xs ${theme.textMuted} hover:${theme.accent} transition-colors flex items-center group`}>
                            <FileText className="w-3 h-3 mr-1" />
                            Terms
                            <div className="absolute -top-6 hidden group-hover:block bg-black/80 text-white text-xs py-1 px-2 rounded">
                                Terms of Service
                            </div>
                            </button>
                            
                            <div className="w-1 h-1 rounded-full bg-gray-500/30"></div>
                            
                            <button className={`text-xs ${theme.textMuted} hover:${theme.accent} transition-colors flex items-center group`}>
                            <HelpCircle className="w-3 h-3 mr-1" />
                            Support
                            <div className="absolute -top-6 hidden group-hover:block bg-black/80 text-white text-xs py-1 px-2 rounded">
                                Get Help
                            </div>
                            </button>
                            
                            <div className="w-1 h-1 rounded-full bg-gray-500/30"></div>
                            
                            
                        </div>

                        {/* Right: Developer Credit with Social Links */}
                        <div className="flex items-center space-x-4">
                            <div className={`text-xs ${theme.textMuted} flex items-center`}>
                            <span>Powered by</span>
                            <span className={`mx-1 ${theme.text} font-medium`}>F/N The_geek</span>
                            <span>© {new Date().getFullYear()}</span>
                            </div>
                            
                            <div className="h-4 w-px bg-gray-500/30"></div>
                            
                            {/* Social Links */}
                            <div className="flex items-center space-x-2">
                            <a href="#" className={`p-1 rounded ${theme.textMuted} hover:${theme.accent} transition-colors`}>
                                <Twitter className="w-3 h-3" />
                            </a>
                            <a href="#" className={`p-1 rounded ${theme.textMuted} hover:${theme.accent} transition-colors`}>
                                <Github className="w-3 h-3" />
                            </a>
                            <a href="#" className={`p-1 rounded ${theme.textMuted} hover:${theme.accent} transition-colors`}>
                                <Linkedin className="w-3 h-3" />
                            </a>
                            </div>
                        </div>
                        </div>

                    {/* Additional Footer Row - App Download Links */}
                    <div className="mt-4 pt-4 border-t border-gray-500/30 flex flex-col sm:flex-row items-center justify-between space-y-3 sm:space-y-0">
                        <div className={`text-xs ${theme.textMuted}`}>
                        Download our mobile app for better experience
                        </div>
                        
                        <div className="flex items-center space-x-3">
                        <button className={`flex items-center text-xs ${theme.text} bg-black/5 dark:bg-white/5 py-1.5 px-3 rounded-lg border ${theme.border}`}>
                            <svg className="w-4 h-4 mr-1.5" viewBox="0 0 384 512">
                            <path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                            </svg>
                            App Store
                        </button>
                        
                        <button className={`flex items-center text-xs ${theme.text} bg-black/5 dark:bg-white/5 py-1.5 px-3 rounded-lg border ${theme.border}`}>
                            <svg className="w-4 h-4 mr-1.5" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
                            </svg>
                            Play Store
                        </button>
                        </div>
                    </div>
                    </div>


                </div>
                );
        default:
        return (
            <div className={`${theme.cardBg} backdrop-blur-xl rounded-3xl p-12 border text-center`}>
            <Smartphone className={`w-16 h-16 ${theme.accent} mx-auto mb-4`} />
            <h3 className={`text-xl font-semibold ${theme.text} mb-2`}>Feature Coming Soon</h3>
            <p className={`${theme.textMuted}`}>This feature is currently under development.</p>
            </div>
        );
  
    };


    
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br ${theme.bg} transition-all duration-300`}>
      {/* Header */}
      {/* Advanced Hideable Header */}
      <div 
        ref={headerRef}
        className={`
          fixed top-0 left-0 right-0 z-50 
          backdrop-blur-xl border-b
          transition-all duration-500 ease-out
          ${visible ? 'translate-y-0' : '-translate-y-full'}
          ${scrolled 
            ? 'bg-white/20 dark:bg-black/20 border-white/20 dark:border-black/30' 
            : 'bg-white/5 dark:bg-black/5 border-white/10 dark:border-black/20'
          }
        `}
      >
        <div className="flex items-center justify-between p-3 max-w-7xl mx-auto">
          {/* Logo with subtle animation */}
        <div className="flex items-center transition-transform duration-300 hover:scale-105">
          <div>
            <img 
              src={logo} 
              alt="LoanPro" 
              className="w-12 h-12 filter drop-shadow-md"
            />
          </div>

          

        {!scrolled && (
          <div className="flex flex-col">
            <span className="text-xl font-bold text-gray-900 dark:text-white">
              Quant
            </span>
            <span className="text-xs text-cyan-600 font-medium tracking-wide">
              FINANCIAL • INVESTMENTS
            </span>
          </div>
        )}

          </div>
          
          {/* Action Buttons */}
          <div className="flex items-center space-x-1">
            {/* Theme Toggle */}
            <button 
              onClick={toggleTheme}
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:scale-110 hover:bg-white/5"
              aria-label="Toggle theme"
            >
              {isDarkMode ? (
                <Sun className="w-6 h-6 text-amber-500 transition-transform hover:rotate-45" />
              ) : (
                <Moon className="w-6 h-6 text-blue-500 transition-transform hover:rotate-45" />
              )}
            </button>
            
            {/* Notifications with bounce animation */}
            <button className="w-8 h-8 rounded-lg flex items-center justify-center relative transition-all hover:scale-110 hover:bg-white/5">
              <Bell className="w-6 h-6 text-gray-500 transition-transform hover:shake" />
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
                <span className="text-white text-xs font-bold">3</span>
              </div>
            </button>
          </div>
        </div>
      </div>

     
      
      {/* Main Content */}
      <div className="px-4 pb-32 max-w-7xl pt-16 mx-auto">
        {renderMainContent()}
      </div>

      {/* Transparent Bottom Navigation */}
     <div className="fixed bottom-0 left-0 right-0 p-4 z-50">
          <div className="max-w-md mx-auto lg:max-w-4xl relative">
            {/* Transparent container */}
            <div
              className={`
                backdrop-blur-sm 
                bg-white/5 dark:bg-black/5 
                rounded-xl
                relative
              `}
            >
              <div className="flex justify-around items-center py-2 relative">
                {/* Dashboard Button */}
                <button
                  onClick={() => setCurrentView("applyloan")}
                  className="p-2 transition-colors group"
                >
                  <PlusCircle
                    className={`
                      ${currentView === "applyloan"
                        ? "text-blue-500 w-5 h-5"
                        : `${theme.textMuted} w-7 h-7 group-hover:text-blue-400`
                      }
                    `}
                  />
                </button>

                {/* Loans Button */}
                <button
                  onClick={() => setCurrentView("payloan")}
                  className="p-2 transition-colors group"
                >
                  <Wallet
                    className={`
                      ${currentView === "payloan"
                        ? "text-blue-500 w-5 h-5"
                        : `${theme.textMuted} w-7 h-7 group-hover:text-blue-400`
                      }
                    `}
                  />
                </button>

                {/* Central Floating Logo */}
                <div className="absolute left-1/2 -translate-x-1/2 -top-6">
                  <button
                    className="p-4 rounded-full bg-inherit shadow-md
                              transition-transform hover:scale-110 hover:shadow-lg
                              focus:outline-none focus:ring-2 focus:ring-blue-400"
                    onClick={() => setCurrentView("dashboard")}
                  >
                    <img
                      src={logo}
                      alt="App"
                      className="w-14 h-14 object-contain"
                    />
                  </button>
                  
                </div>

                {/* Analytics Button */}
                <button
                  onClick={() => setCurrentView("settings")}
                  className="p-2 transition-colors group"
                >
                  <Settings2Icon
                    className={`
                      ${currentView === "settings"
                        ? "text-blue-500 w-5 h-5"
                        : `${theme.textMuted} w-7 h-7 group-hover:text-blue-400`
                      }
                    `}
                  />
                </button>

                {/* Profile Button */}
                <button
                  onClick={() => setCurrentView("profile")}
                  className="p-2 transition-colors group"
                >
                  <User
                    className={`
                      ${currentView === "profile"
                        ? "text-blue-500 w-5 h-5"
                        : `${theme.textMuted} w-7 h-7 group-hover:text-blue-400`
                      }
                    `}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

{/* CSS for shake animation */}
      <style >{`
        @keyframes shake {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-5deg); }
          75% { transform: rotate(5deg); }
        }
        .hover\:shake:hover {
          animation: shake 0.5s ease-in-out;
        }
      `}</style>

    </div>
  );
};

export default BorrowersHome;